"use strict";

/**
 * @file
 * COMPANY CUSTOMERS
 * Make Vidyard Images the same height as core Images.
 */

(function ($, Drupal) {
  /**
   * Function to get the height of core Image and apply to Vidyard Images
   * */
  function setVidyardHeight() {
    var imageHeight = $('article.node .media__image').height();
    var $vidyardImage = $('article.node .vidyard-player-embed');
    $vidyardImage.css('height', imageHeight + 'px');
  }
  Drupal.behaviors.Customers = {
    attach: function attach() {
      var path = window.location.pathname;

      // Check if the path matches "/company/customers"
      if (path === '/company/customers') {
        $(window).on('load', function () {
          setVidyardHeight();
        });
        $(window).resize(function () {
          if (document.documentElement.clientWidth <= 1024) {
            setVidyardHeight();
          }
        }).resize();
        $(document).ajaxStop(function () {
          setVidyardHeight();
        });
      }
    }
  };
})(jQuery, Drupal);